<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      d="M4.16634 19.7917H6.24967V11.4583H18.7497V19.7917H20.833V8.69792L12.4997 5.36458L4.16634 8.69792V19.7917ZM2.08301 21.875V7.29167L12.4997 3.125L22.9163 7.29167V21.875H16.6663V13.5417H8.33301V21.875H2.08301ZM9.37467 21.875V19.7917H11.458V21.875H9.37467ZM11.458 18.75V16.6667H13.5413V18.75H11.458ZM13.5413 21.875V19.7917H15.6247V21.875H13.5413Z"
      fill="currentColor"
    />
  </svg>
</template>
